<ng-template [ngxPermissionsOnly]="['automations:can_get_automations_reports_actions']">
  <div class="box-row panel panel-default align-content-center">
    <div class="panel-body text-center text-alpha">
      <div *ngIf="!isCountLoaded" class="whirl standard spinnermargin"></div>
      <ng-template [ngIf]="isCountLoaded">
        <div class="text-lg mo">{{websiteVisitorsCount}}</div>
        <p>Actions Run Last 7 Days</p>
        <div class="mb-lg"></div>
      </ng-template>
    </div>
  </div>
</ng-template>